/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ host: NonNullable<unknown> }} Placewebworkingeyebrow3Inputs */

const en_placewebworkingeyebrow3 = /** @type {(inputs: Placewebworkingeyebrow3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Reading ${i?.host}`)
};

const de_placewebworkingeyebrow3 = /** @type {(inputs: Placewebworkingeyebrow3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.host} wird gelesen`)
};

/**
* | output |
* | --- |
* | "Reading {host}" |
*
* @param {Placewebworkingeyebrow3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebworkingeyebrow3 = /** @type {((inputs: Placewebworkingeyebrow3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebworkingeyebrow3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebworkingeyebrow3(inputs)
	return de_placewebworkingeyebrow3(inputs)
});
export { placewebworkingeyebrow3 as "placeWebWorkingEyebrow" }